/**
 * Contact Form front-end behaviour.
 *
 * T-063 (2026-10-02): the brief is sent for real. The form posts to the theme endpoint
 * (`action`, `inc/contact.php`), which mails it through Resend, and the confirmation panel
 * replaces the form ONLY when the endpoint answers `sent`. Any other answer prints the
 * block's error or busy line under the button and keeps what the visitor typed, so a
 * failed send is never dressed up as "Got it."
 *
 * `ac_back` is dropped from the request: it exists for the no-JS round trip only, where the
 * endpoint redirects back instead of answering JSON.
 *
 * The panel markup mirrors the reference branch, `role="status"` included, so a screen
 * reader hears the confirmation.
 */

function buildSuccessPanel( form ) {
	const panel = document.createElement( 'div' );
	panel.className = 'flex flex-col justify-center';
	panel.setAttribute( 'role', 'status' );

	const title = document.createElement( 'p' );
	title.className = 'text-body-1-m text-grey-100 mb-2';
	title.textContent = form.dataset.successTitle || '';

	const body = document.createElement( 'p' );
	body.className = 'text-body-1-r text-grey-70';
	body.textContent = form.dataset.successBody || '';

	panel.append( title, body );
	return panel;
}

function initContactForm( form ) {
	const status = form.querySelector( '[data-contact-status]' );
	const button = form.querySelector( 'button[type="submit"]' );

	form.addEventListener( 'submit', async ( event ) => {
		event.preventDefault();
		if ( button.disabled ) {
			return;
		}
		button.disabled = true;
		if ( status ) {
			status.textContent = '';
		}

		const body = new FormData( form );
		body.delete( 'ac_back' );

		let state = 'error';
		try {
			const response = await fetch( form.action, {
				method: 'POST',
				body,
				credentials: 'omit',
			} );
			const data = await response.json().catch( () => ( {} ) );
			state = data.status || 'error';
		} catch {
			state = 'error';
		}

		if ( 'sent' === state ) {
			form.replaceWith( buildSuccessPanel( form ) );
			return;
		}

		button.disabled = false;
		if ( status ) {
			status.textContent =
				'busy' === state ? form.dataset.busy : form.dataset.error;
		}
	} );
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll(
			'.wp-block-avoid-content-contact-form form[data-contact-form]'
		)
		.forEach( initContactForm );
} );
